import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/transitional/components/View';
import { generatePath, useHistory } from 'quartz-routing/react-router';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Paths } from '../../constants/paths';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { CollectionPreviewThumbnails } from './CollectionPreviewThumbnails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionCard({
  buttonText,
  description,
  href,
  illustration,
  name,
  onClick,
  removeCardWrapper,
  slug,
  previewItems = [],
  totalItemCount = 0
}) {
  const scrollToTop = useScrollToTop();
  const history = useHistory();
  const collectionUrl = href || slug && generatePath(Paths.FEATURED_COLLECTION, {
    collectionSlug: slug
  });
  const handleThumbnailClick = () => {
    onClick === null || onClick === void 0 || onClick();
    if (collectionUrl) history.push(collectionUrl);
    scrollToTop();
  };
  const textContent = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    flexGrow: 1,
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      overflowWrap: "break-word",
      typography: "heading-300",
      children: name
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: description,
        WrapperComponent: "span"
      })
    })]
  });
  const content = /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    flexDirection: "column",
    gap: "800",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      flexGrow: 1,
      children: illustration ? /*#__PURE__*/_jsx(MediaObject, {
        align: "stretch",
        itemRight: /*#__PURE__*/_jsx(View, {
          maxInlineSize: "125px",
          maxBlockSize: "125px",
          children: illustration
        }),
        children: textContent
      }) : textContent
    }), /*#__PURE__*/_jsxs(Flex, {
      flexWrap: "wrap-reverse",
      gap: "400",
      children: [/*#__PURE__*/_jsx(RouterButton, {
        external: false,
        marginInlineEnd: "auto",
        onClick: () => {
          onClick === null || onClick === void 0 || onClick();
          scrollToTop();
        },
        to: collectionUrl,
        use: "tertiary-extra-light",
        children: buttonText ? /*#__PURE__*/_jsx(Text, {
          as: "span",
          textWrap: "wrap",
          textAlign: "left",
          children: buttonText
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.collectionCard.viewCollection"
        })
      }), !illustration && previewItems.length > 0 && /*#__PURE__*/_jsx(CollectionPreviewThumbnails, {
        previewItems: previewItems,
        totalItemCount: totalItemCount,
        onCollectionClick: handleThumbnailClick
      })]
    })]
  });
  if (removeCardWrapper) return /*#__PURE__*/_jsx(View, {
    blockSize: "100%",
    children: content
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    margin: "0",
    children: /*#__PURE__*/_jsx(CardSection, {
      blockSize: "100%",
      children: content
    })
  });
}